import * as React from "react";
import { useParams } from "react-router";
import { useGetProgramClassQuery } from "../reducers/registerapi";
import Loading from "../components/loading";
import HtmlDiv from "../components/htmldiv";

const ProgramClass = () => {
    const { programclassid } = useParams();
    const { data, isSuccess, error } = useGetProgramClassQuery({
        id: programclassid ?? "?",
    }, {});

    if (error) {
        return (
            <div className="alert alert-danger">
                Sorry, we cannot find that program!
            </div>
        );
    }

    if (!isSuccess) {
        return <Loading />;
    }

    return (
        <div className="container py-3">
            <h3>{data.programName}</h3>
            <HtmlDiv html={data.descriptionHtml} />
        </div>
    );
};

export default ProgramClass;
